import React from "react";
import "../CSS/ProductSub.css";
import product1 from "../Assets/Throws/1.jpg";
import product2 from "../Assets/Throws/2.jpg";
import product3 from "../Assets/Throws/3.jpg";
import product4 from "../Assets/Throws/4.jpg";

function Throws() {
  window.scrollTo(0, 0);
  return (
    <div className="product-sub-main">
      <div className="product-sub-head">
        <h3>Throws</h3>
      </div>
      <div className="product-sub-body">
        <div className="product-sub-flex">
          <img src={product1}></img>
          <img src={product2}></img>
        </div>
        <div className="product-sub-flex">
          <img src={product3}></img>
          <img src={product4}></img>
        </div>
      </div>
    </div>
  );
}
export default Throws;
